/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsEmailTokenResponseErrorSchema
 */
export interface NotificationsEmailTokenResponseErrorSchema {
    /**
     * 
     * @type {string}
     * @memberof NotificationsEmailTokenResponseErrorSchema
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsEmailTokenResponseErrorSchema interface.
 */
export function instanceOfNotificationsEmailTokenResponseErrorSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsEmailTokenResponseErrorSchemaFromJSON(json: any): NotificationsEmailTokenResponseErrorSchema {
    return NotificationsEmailTokenResponseErrorSchemaFromJSONTyped(json, false);
}

export function NotificationsEmailTokenResponseErrorSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsEmailTokenResponseErrorSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function NotificationsEmailTokenResponseErrorSchemaToJSON(value?: NotificationsEmailTokenResponseErrorSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

